export function obterListaStatus() {
  return (
    [
      { label: 'Selecione...', value: '' },
      { label: 'Edição', value: 'EDICAO' },
    ]
  );
}
